<template>
	<div class="listInventoryTemplateComponent">
		<button ref="btnSetComponentLocal" @click="setComponentLocal()" v-show="false">Set Component</button>
		<nav class="navbar navbar-expand-lg navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control mr-sm-2 form-control-sm" type="search" v-show="false" placeholder="Buscar articulo" aria-label="Buscar" v-on:keyup.enter="getAllInventoryTemplateDetailForInventoryIdLocal(1)" v-model="searchInventoryTemplate">
				<button class="btn btn-primary my-2 my-sm-0 btn-sm" ref="btngetInventoryTemplatesForYearLocal" @click="getInventoryTemplatesForYearLocal(1)" :disabled="loadingInventoryTemplates">Buscar</button>
			</div>
		</nav>
		<div class="table-responsive" v-if="!loadingInventoryTemplates">
			<table class="table table-sm table-hover">
				<thead>
					<tr>
						<th class="text-center align-middle" @click="setComponentLocal()">ID</th>
						<th class="align-middle">Nombre</th>
						<th class="text-center align-middle">Año</th>
						<th class="text-center align-middle">Creación</th>
						<th class="align-middle">Asignado</th>
						<th class="align-middle">Ubicación {{ disabled  }}</th>
						<th class="align-middle text-right">
							<button class="fas fa-plus margin-right5 pointer" title="Nuevo inventario" @click="showCreateInventoryTemplateComponentModalLocal" :disabled="disabled"></button>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="listInventoryTemplates.length == 0">
						<td colspan="6" class="text-center">No hay planillas para este periodo</td>
					</tr>
					<tr v-for="(item, index) in listInventoryTemplates" :key="index">
						<td class="text-center align-middle">{{ item.id }}</td>
						<td class="align-middle">{{ item.name }}</td>
						<td class="text-center align-middle">{{ item.inventory.year }}</td>
						<td class="text-center align-middle">{{ item.created_at }}</td>
						<td class="align-middle">
							<div v-for="(ite, inde) in item.inventory_template_employee" :key="inde">
								{{ ite.surname }} {{ ite.name }}
							</div>
							<div class="text-">
								<i @click="showAssignInventoryTemplateEmployeeModal(item)" class="pointer text-secondary"><small>asignar a trabajador</small></i>
							</div>
						</td>
						<td class="align-middle">
							<span class="pointer" @click="showSideComponent(item)">
								<i class="fas fa-table mx-1" title="Ver modulos" :style="'color: ' + colorSide(item)"></i> {{ nameSide(item) }}
							</span>
						</td>
						<td class="align-middle text-right">
							<router-link :to="'/inventoryTemplate/' + item.id" class="fas fa-eye text-info" title="Ver planilla"></router-link>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else class="text-center">
			Buscando Planillas...
		</div>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#createInventoryTemplateComponentModal" ref="btnShowCreateInventoryTemplateComponentModal" v-show="false">
			Asignar Planilla
		</button>
		<!-- Modal -->
		<div class="modal fade" id="createInventoryTemplateComponentModal" tabindex="-1" aria-labelledby="createInventoryTemplateComponentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-body">
						<create-inventory-template-component
							ref="createInventoryTemplateComponent"
							:inventoryId="inventoryId"
							@actionSaveInventoryTemplate="actionSaveInventoryTemplateLocal">
						</create-inventory-template-component>
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="btnCloseInventoryTemplateComponentModal" v-show="false">Cerrar</button>
					</div>
				</div>
			</div>
		</div>


		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#assignInventoryTemplateEmployeeModal" ref="btnShowAssignInventoryTemplateEmployeeModal" v-show="false">
			Asignar Planilla
		</button>

		<!-- Modal -->
		<div class="modal fade" id="assignInventoryTemplateEmployeeModal" tabindex="-1" aria-labelledby="assignInventoryTemplateEmployeeModal" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="assignInventoryTemplateEmployeeModal">Asignar Planilla {{objectInventoryTemplate.id}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div v-if="objectInventoryTemplate.inventory_template_employee.length < maxCount">
							<div>
								<label>Nombre planilla</label> <span>{{objectInventoryTemplate.name}}</span>
							</div>
							<div>
								<select class="form-control form-control-sm" v-model="employeeIdSelected">
									<option v-for="(item, index) in listEmployeesFilter" :key="index" :value="item.id">{{ item.surname }} {{ item.name }}</option>
								</select>
							</div>
							<div>
								Conteo Nº {{ objectInventoryTemplate.inventory_template_employee.length + 1 }}
							</div>
						</div>
						<div class="text-center" v-else>
							La planilla {{ objectInventoryTemplate.name }} (ID:{{ objectInventoryTemplate.id }}) ya tiene asignado el máximo de contadores
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="btnCloseAssignInventoryTemplateEmployeeModal">Cerrar</button>
						<button type="button" class="btn btn-sm btn-primary" @click="saveInventoryTemplateEmployeeLocal" :disabled="employeeIdSelected == 0 || savingInventoryTemplateEmployee">Asignar</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#sideComponentComponentModal" ref="btnShowSideComponentComponentModal" v-show="false">
			Asignar Planilla
		</button>
		<!-- Modal -->
		<div class="modal fade" id="sideComponentComponentModal" tabindex="-1" aria-labelledby="sideComponentComponentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-body">
						<div v-for="(item, index) in storeRackSideIds" :key="index">
							<side-component
								ref="sideComponent"
								:id="item"
								:storeRackSideRowColumnIds="storeRackSideRowColumnIds">
							</side-component>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="btnCloseAssignInventoryTemplateEmployeeModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventories from '@/mixins/inventories'
	import inventoryTemplate from '@/mixins/inventories/inventoryTemplate.js'
	import employee from '@/mixins/employees'

	import CreateInventoryTemplateComponent from '@/components/CreateInventoryTemplateComponent.vue'
	import SideComponent from '@/components/SideComponent.vue'

	export default {
		name: 'ListInventoryTemplateComponent',
		mixins: [axiosAction, errors, mixin, inventories, inventoryTemplate, employee],
		props: ['inventoryId', 'disabled'],
		data() {
			return {
				maxCount: 4,
				storeRackSideIds: [],
				storeRackSideRowColumnIds: []
			}
		},
		components: {
			'create-inventory-template-component': CreateInventoryTemplateComponent,
			'side-component': SideComponent,
		},
		computed: {
			listEmployeesFilter() {
				let list = []
				let r = true
				list = this.listEmployees.filter((e) => {
						r= true
						this.objectInventoryTemplate.inventory_template_employee.forEach((el) => {
							if(parseInt(el.id) == parseInt(e.id)) {
								r = false
							}
						})
						return r
				})
				return list
			}
		},
		methods: {
			actionSaveInventoryTemplateLocal(data) {
				this.$refs.btnCloseInventoryTemplateComponentModal.click()
				this.addListInventoryTemplates(data)
			},
			colorSide(item) { 
				return (item.inventory_template_store_rack_side_row_column.length > 0) ? item.inventory_template_store_rack_side_row_column[0].store_rack_side.color : ''
			},
			nameSide(item) {
				let name = 'Sin determinar'
				if(item.inventory_template_store_rack_side_row_column.length > 0) {
					name = item.inventory_template_store_rack_side_row_column[0].store.name
					name+= ' ' + item.inventory_template_store_rack_side_row_column[0].store_rack.name
					name+= ' ' + item.inventory_template_store_rack_side_row_column[0].store_rack_side.name
				}
				return name
			},
			getAllEmployeesLocal() {
				this.getAllEmployees()
			},
			getAllEmployeesResultLocal(response) {},
			getAllInventoriesResultLocal(response) {},
			getInventoryTemplatesForYearLocal() {
				this.storeRackSideIds = []
				this.getInventoryTemplatesForYear(this.inventoryId)
			},
			getAllInventoryTemplatesResultLocal(response) {},
			initComponentLocal() {
				this.setComponentLocal()
			},
			setComponentLocal() {
				this.getAllEmployeesLocal()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllEmployeesResult': this.getAllEmployeesResult(response); break;
					case 'getAllInventoriesResult': this.getAllInventoriesResult(response); break;
					case 'getAllInventoryTemplatesResult': this.getAllInventoryTemplatesResult(response); break;
					case 'saveInventoryTemplateEmployeeResult': this.saveInventoryTemplateEmployeeResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveInventoryTemplateEmployeeLocal() {
				let data = {
						exist: 0,
						id: 0,
						inventory_template_id: this.objectInventoryTemplate.id,
						employee_id: this.employeeIdSelected,
						count_x: this.objectInventoryTemplate.inventory_template_employee.length + 1
					}
				this.saveInventoryTemplateEmployee(this.objectInventoryTemplate.id, data)
			},
			saveInventoryTemplateEmployeeResultLocal(response) {
				if(response.data.success == true) {
					this.employeeIdSelected = 0
					this.$refs.btnCloseAssignInventoryTemplateEmployeeModal.click()
					let index = this.listInventoryTemplates.map((el) => parseInt(el.id)).indexOf(response.data.data.inventory_template_id)
					if(index > -1) {
						this.listInventoryTemplates[index].inventory_template_employee.push(response.data.data.employee)
					}
				}
			},
			showAssignInventoryTemplateEmployeeModal(item) {
				this.employeeIdSelected = 0
				this.setObjectInventoryTemplate(item)
				this.$refs.btnShowAssignInventoryTemplateEmployeeModal.click()
			},
			showCreateInventoryTemplateComponentModalLocal() {
				this.$refs.btnShowCreateInventoryTemplateComponentModal.click()
				this.$refs.createInventoryTemplateComponent.$refs.btnSetComponentLocal.click()
			},
			showSideComponent(item) {
				this.storeRackSideIds = []
				this.storeRackSideRowColumnIds = []
				let index = -1
				item.inventory_template_store_rack_side_row_column.forEach((e) => {
					index = this.storeRackSideIds.map(e => parseInt(e)).indexOf(parseInt(e.store_rack_side_id))
					if(index == -1) {
						this.storeRackSideIds.push(e.store_rack_side_id)
					}
					index = this.storeRackSideRowColumnIds.map(e => parseInt(e)).indexOf(parseInt(e.id))
					if(index == -1) {
						this.storeRackSideRowColumnIds.push(e.id)
					}
				})
				this.$refs.btnShowSideComponentComponentModal.click()
				setTimeout(() => {  this.$refs.sideComponent[0].$refs.btnGetStoreRackSide.click() }, 100)
			},
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
